import { createClient } from '@supabase/supabase-js'

// Get current environment
const currentEnv = import.meta.env.VITE_ENV || 'local'

// Environment-specific Supabase configuration
const getSupabaseConfig = () => {
  switch (currentEnv) {
    case 'production':
      return {
        url: import.meta.env.VITE_PROD_SUPABASE_URL,
        key: import.meta.env.VITE_PROD_SUPABASE_ANON_KEY
      }
    case 'development':
      return {
        url: import.meta.env.VITE_DEV_SUPABASE_URL,
        key: import.meta.env.VITE_DEV_SUPABASE_ANON_KEY
      }
    case 'local':
    default:
      return {
        url: import.meta.env.VITE_LOCAL_SUPABASE_URL,
        key: import.meta.env.VITE_LOCAL_SUPABASE_ANON_KEY
      }
  }
}

const { url: supabaseUrl, key: supabaseAnonKey } = getSupabaseConfig()

// Log current environment (helpful for debugging)
console.log(`Using Supabase environment: ${currentEnv}`)

// Fallback storage implementation that matches Storage interface
const createMemoryStorage = () => {
  const storage = new Map<string, string>()
  
  return {
    getItem: (key: string) => storage.get(key) || null,
    setItem: (key: string, value: string) => {
      storage.set(key, value)
    },
    removeItem: (key: string) => {
      storage.delete(key)
    }
  } as Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
}

const memoryStorage = createMemoryStorage()

// Try to use localStorage, fallback to memory storage if not available
const getStorage = () => {
  try {
    // Test localStorage access
    localStorage.setItem('supabase.test', 'test')
    localStorage.removeItem('supabase.test')
    return localStorage
  } catch {
    console.warn('localStorage not available, falling back to memory storage')
    return memoryStorage
  }
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: getStorage()
  }
})
